import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { CoolLocalStorage } from '@angular-cool/storage';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { AccessibilitySetting } from './accessibility-setting.interface';
import { bcSessionKeys } from 'common/common/constants/session-keys';
import { accessibilitySettingsConfig } from './accessibility-settings-config';
import { MenuFocusParentDirective } from '../shared/menu-focus-handler';
import { Focusable } from 'shared/models/focus/focus.model';

@Component({
  selector: 'app-accessibility-settings',
  templateUrl: './accessibility-settings.component.html',
  styleUrls: ['./accessibility-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AccessibilitySettingsComponent implements Focusable, OnInit {
  accessibilitySettings: AccessibilitySetting[] = [];

  @ViewChild(MenuFocusParentDirective, { read: ElementRef })
  private focusParent: ElementRef;

  @Input()
  isFocusable: boolean;

  constructor(private _bcAnalytics: BcAnalytics,
              private _rxEmitter: RxEmitter,
              private _localStorage: CoolLocalStorage) {
  }

  ngOnInit(): void {
    const storedAccessibilitySettings = this._localStorage.tryGetObject(bcSessionKeys.storage.accessibilitySettings);
    if (storedAccessibilitySettings) {
      this.accessibilitySettings = Object.keys(storedAccessibilitySettings)
        .map(key => storedAccessibilitySettings[key]);
    } else {
      this.accessibilitySettings = accessibilitySettingsConfig;
    }
  }

  focus(): void {
    this.focusParent.nativeElement.focus();
  }

  toggleSetting(setting: AccessibilitySetting): void {
    setting.isTurnedOn = !setting.isTurnedOn;
    this._rxEmitter.send(MessageBusEvents.AccessibilitySetting + setting.name, setting);
    this._bcAnalytics.eventTrack('AccessibilitySettingChanged', { setting });
    this._localStorage.setObject(bcSessionKeys.storage.accessibilitySettings, this.accessibilitySettings);
  }
}
